module.exports = __webpack_public_path__ + "kids_birthday-doodles_1.jpg";